import React, { FC } from "react";
import cn from "classnames";
import { SVGReactComponent } from "src/@types";

interface Props {
  className?: string;
  icon: SVGReactComponent;
  count: number;
}
export const AlertBadge: FC<Props> = ({ icon: Icon, count, className }) => (
  <div className="relative">
    <Icon className={cn("w-8 h-8", className)} />
    {/* add some padding in future */}
    <span className="absolute -top-2 -right-3 flex justify-center text-center items-center w-4 h-4 text-10 leading-0 font-medium bg-rose-base text-white-base rounded-full">
      {count}
    </span>
  </div>
);
